import { useMonitor } from '../use-monitor';

export function useMonitorStartActionSubmit() {
  return useMonitor('start-action-submit');
}
